import api from "@/services/api";

export default {
    getFile(file_id) {
        return api.get(`files/${file_id}/`)
            .then((response) => response.data);
    },
}